module.exports = __webpack_public_path__ + "img/19.d6272134.jpg";